import { combineReducers } from 'redux-immutablejs';

import globalReducer from './global';
import searchReducer from './search';
import propertyReducer from './property';
import assignmentReducer from './assignment';
import logReducer from './log';

export default combineReducers({
  global: globalReducer,
  search: searchReducer,
  property: propertyReducer,
  assignment: assignmentReducer,
  log: logReducer,
});
